export enum OnboardingRequestTypes {
    required = 'required',
    optional = 'optional',
}
